<template>
    <div id="feed" class="mx-n2 mx-md-0">
        <Feed
            class="pt-md-3 transition-up-1"
            :query="query"
            :feedName="name"
            :roomName="`feed-${name}`"
        />
    </div>
</template>

<script>
import Feed from '~/components/feed/Feed.vue';

export default {
    components: {
        Feed
    },

    scrollToTop: false,

    props: ['profile', 'type', 'isModer'],

    data () {
        return {}
    },

    computed: {
        query () {
            let query = {}
            let key = this.type == 'user' ? 'users' : 'companies'
            query[key] = this.profile.id

            return query;
        },

        name () {
            return `${this.type}-${this.profile.id}`
        }
    }


}
</script>

<style scoped>
    .moder-placeholder  {
        background-color: var(--color-cases-purple-dim);
        border-radius: 8px;
        text-align: center;
    }
</style>
